import React from 'react';
export var RestrictedTeamViewContext = React.createContext(undefined);
export var useRestrictedTeamView = function () {
    var restrictedTeamViewState = React.useContext(RestrictedTeamViewContext);
    if (!restrictedTeamViewState) {
        // eslint-disable-next-line no-console
        console.warn('Please setup <RestrictedTeamViewProvider /> as a parent component, before using useRestrictedTeamView() otherwise you will get default RestrictedTeamViewState');
        return {
            restrictedViewResponse: undefined,
            teamRestrictedView: false,
            restrictedViewLoading: false,
            fetchNextPage: undefined,
        };
    }
    return restrictedTeamViewState;
};
//# sourceMappingURL=context.js.map